import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
} from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { Dot } from "lucide-react";
import {
  CatalogueItem,
} from "@/features/user-profile/subscriptions/subscriptions";
import { useEffect, useMemo, useState } from "react";
import { IoIosInformationCircle } from "react-icons/io";
import {
  HoverCard,
  HoverCardContent,
  HoverCardTrigger,
} from "../ui/hover-card";
import {
  AddONUser
} from "@/features/user-profile/services/subscriptionServices";
// import toastService from "@/services/toastService";
import { useLoading } from "@/contexts/LoadingContext";
import toastService from "@/services/toastService";

interface ConfirmDeleteDialogProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  initialCatalogueLicences: CatalogueItem[];
  // filteredPlans: CatalogueProduct[];
  type: string;
}

const SubscriptionInitialdaialog: React.FC<ConfirmDeleteDialogProps> = ({
  open,
  onOpenChange,
  initialCatalogueLicences,
}) => {
   const { setLoading } = useLoading();
  const [activeTab, setActiveTab] = useState<string>("");

  const [showTable, setShowTable] = useState(false);
  const [quantities, setQuantities] = useState<Record<string, number>>({});
  const [isSubmitting, setIsSubmitting] = useState(false);


  const tabs = initialCatalogueLicences.map((group) => ({
    key: `${group.intervalCount}_${group.interval}`,
    label: group.title,
  }));

  useEffect(() => {
    if (initialCatalogueLicences.length > 0) {
      const defaultKey = `${initialCatalogueLicences[0].intervalCount}_${initialCatalogueLicences[0].interval}`;
      setActiveTab(defaultKey);
    }
  }, [initialCatalogueLicences]);

  useEffect(() => {
    if (!open) {
      // Reset all form-related states when dialog closes
      setQuantities({});
      setShowTable(false);
      setActiveTab("");
    }
  }, [open]);

  const selectedGroup = initialCatalogueLicences.find(
    (group) => `${group.intervalCount}_${group.interval}` === activeTab
  );

  const handleQuantityChange = (productId: string, newQty: number) => {
    if (newQty < 0) return;
    setQuantities((prev) => ({ ...prev, [productId]: newQty }));
  };

  const subUserSubtotal = useMemo(() => {
    return (selectedGroup?.subUserCataloguePrices || []).reduce((sum, item) => {
      const qty = quantities[item.price_id] || 0;
      return sum + qty * item.price;
    }, 0);
  }, [selectedGroup, quantities]);

  const grandTotal = useMemo(() => {
    return (selectedGroup?.price || 0) + subUserSubtotal;
  }, [selectedGroup, subUserSubtotal]);

const onSubmit = async () => {
  if (isSubmitting) return; // 🔒 Prevent duplicate clicks
  setIsSubmitting(true);
  setLoading(true);

  if (!selectedGroup) {
    // alert("No plan selected.");
    toastService.error("No plan selected")
    
    setLoading(false);
    setIsSubmitting(false);
    return;
  }

  let subUserLicenses: { price_id: string; quantity: number }[] = [];

  if (selectedGroup.showSubUserCatalogue && showTable) {
    subUserLicenses = (selectedGroup.subUserCataloguePrices || [])
      .filter((item) => (quantities[item.price_id] || 0) > 0)
      .map((item) => ({
        price_id: item.price_id,
        quantity: quantities[item.price_id],
      }));
  }

  const payload = {
    adminPriceId: selectedGroup.price_id,
    subUserLicenses,
  };

  try {
    const result = await AddONUser(payload);
    const checkoutUrl = result?.data?.checkoutSessionUrl;
    const isSubscriptionCreated = result?.data?.isSubscriptionCreated;

    if (isSubscriptionCreated === false && checkoutUrl) {
      window.open(checkoutUrl, "_blank");
      // toastService.success("Subscription Added Successfully!");
    } else {
      onOpenChange(false);
      window.location.reload();
    }

    setQuantities({});
  } catch (error) {
    console.error("Error submitting subscriptions:", error);
    // alert("Something went wrong. Please try again.");
      // toastService.error("No plan selected")
  } finally {
    setLoading(false);
    setIsSubmitting(false);
  }
};


  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent
  className={`w-[60%] p-0 rounded-xl overflow-hidden bg-white ${
    selectedGroup?.showSubUserCatalogue ? 'max-w-[700px]' : 'max-w-[550px]'
  }`}
>
        <DialogHeader className="bg-[#f4f4f4] text-[#202b49] px-6 py-4">
          <DialogTitle className="text-xl font-semibold text-gray-700">
            Add New Subscription
          </DialogTitle>
        </DialogHeader>

        <div className="mt-2 w-[90%] mx-auto">
      
  <div className="flex flex-col gap-y-2">
    <p className="text-[16px] font-medium text-[#828282]"> Select Recurrence</p>
    <div className="grid grid-cols-4 gap-4 mt-1">
      {tabs.map((tab) => (
        <div
          key={tab.key}
          className={`flex items-center gap-2 p-2 h-[40px] border rounded-md cursor-pointer ${
            activeTab === tab.key ? "bg-[#f1fff5] border-[#28af4a]" : "bg-[#f4f4f4] border-transparent"
          }`}
          onClick={() => setActiveTab(tab.key)}
        >
        <span
  className={`w-5 h-5 rounded-full flex items-center justify-center 
    ${activeTab === tab.key ? "border-2 border-[#28af4a]" : "border border-gray-300"}`}
>
  <input
    type="radio"
    name="recurrenceTab"
    checked={activeTab === tab.key}
    onChange={() => {}}
    className="appearance-none w-3 h-3 rounded-full bg-white checked:bg-[#28af4a]"
  />
</span>

          <span className="capitalize text-sm font-medium">{tab.label}</span>
        </div>
      ))}
    </div>
  </div>



          {selectedGroup?.showSubUserCatalogue && (
            <div className="mt-4 mr-2">
              <p className="text-sm text-gray-700 flex items-center mb-2">
                Do you want to add <span className="text-[#1e293b] font-bold mx-1">Sub-Users</span>
                <HoverCard>
                  <HoverCardTrigger asChild>
                    <span className="pr-1">
                      <IoIosInformationCircle />
                    </span>
                  </HoverCardTrigger>
                  <HoverCardContent
                    className="w-50 mt-2 bg-[#323032]"
                    align="start"
                  >
                    <div className="flex  space-x-3">
                      <div className="space-y-0.5 ">
                        {/* <h4 className="text-[20px] text-primary uppercase font-semibold">{item.name}</h4> */}
                        <p className="text-[14px] text-[#ebebeb]/70">
                          Fuel your growth with Salespersons and Managers on board.
                        </p>
                      </div>
                    </div>
                  </HoverCardContent>
                </HoverCard>
                for this plan ?
              </p>
              <div className="flex gap-4 mb-4">
                {/* No Option */}
                <div
                  className={`flex items-center gap-2 p-2 rounded-md h-[40px] border  cursor-pointer ${
                    !showTable ? "bg-[#f1fff5] border-[#28af4a]" : "bg-[#f4f4f4]"
                  }`}
                  onClick={() => {
                    setShowTable(false);
                    setQuantities({ [selectedGroup?.price_id]: 0 });
                  }}
                >
                <label className="inline-flex items-center cursor-pointer">
  <span
    className={`rounded-full w-5 h-5 flex items-center justify-center ${
      !showTable ? "border border-[#28af4a]" : "border border-gray-400"
    }`}
  >
    <input
      type="radio"
      name="showTableOption"
      checked={!showTable}
      onChange={() => {}}
      className="appearance-none w-3 h-3 rounded-full bg-white checked:bg-[#28af4a]"
    />
  </span>
</label>

                  <span className="px-4 py-1 rounded-md">No</span>
                </div>

                {/* Yes Option */}
                <div
                  className={`flex items-center gap-2 p-2 rounded-md h-[40px] border cursor-pointer ${
                    showTable ? "bg-[#f1fff5] border-[#28af4a]" : "bg-[#f4f4f4]"
                  }`}
                  onClick={() => {
                    setShowTable(true);
                    const initialQuantities: Record<string, number> = {};
                    (selectedGroup?.subUserCataloguePrices || []).forEach(
                      (item) => {
                        initialQuantities[item.price_id] = 0;
                      }
                    );
                    setQuantities(initialQuantities);
                  }}
                >
                 <label className="inline-flex items-center cursor-pointer">
  <span
    className={`rounded-full w-5 h-5 flex items-center justify-center ${
      showTable ? "border border-[#28af4a]" : "border border-gray-400"
    }`}
  >
    <input
      type="radio"
      name="showTableOption"
      checked={showTable}
      onChange={() => {}}
      className="appearance-none w-3 h-3 rounded-full bg-white checked:bg-[#28af4a]"
    />
  </span>
</label>

   
                  <span className="px-4 py-1 rounded-md">Yes</span>
                </div>
              </div>

              {showTable && (
                <div className="overflow-hidden rounded-lg border border-gray-200">
                  <table className="w-full text-sm">
                    <thead className="bg-gray-100">
                      <tr>
                        <th className="text-left px-4 py-2 border-b">Plan</th>
                        <th className="text-left px-4 py-2 border-b">
                          Quantity
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      {(selectedGroup?.subUserCataloguePrices || []).map(
                        (subPlan) => (
                          <tr key={subPlan.price_id} className="border-t">
                            <td className="px-4 py-2">
                              <div className="flex items-center">
                                {subPlan.name}
                                <Dot size={30} />
                                <div className="text-[#828282]">
                                  <span>$</span>
                                  <span className="ml-1">{subPlan.price}</span>
                                  <span className="ml-1 uppercase">
                                    {subPlan.currency}
                                  </span>
                                  <span className="ml-2 text-[16px]">
                                    / {subPlan.intervalCount}{" "}
                                    {subPlan.intervalCount > 1
                                      ? `${subPlan.interval}s`
                                      : subPlan.interval}
                                  </span>
                                </div>
                              </div>
                            </td>
                            <td className="px-4 py-2">
                              <div className="flex items-center h-[32px] mt-1 border border-[#e4e4e4] bg-white rounded-[8px] w-[120px]">
                                <button
                                  className="w-[40px] h-full flex items-center justify-center text-md font-bold bg-[#828282] bg-opacity-[0.08]"
                                  onClick={() =>
                                    handleQuantityChange(
                                      subPlan.price_id,
                                      (quantities[subPlan.price_id] || 0) - 1
                                    )
                                  }
                                >
                                  -
                                </button>
                                <span className="text-md font-medium flex-1 text-center text-gray-800">
                                  {quantities[subPlan.price_id] || 0}
                                </span>
                                <button
                                  className="w-[40px] h-full flex items-center justify-center text-md font-bold bg-[#828282] bg-opacity-[0.08]"
                                  onClick={() =>
                                    handleQuantityChange(
                                      subPlan.price_id,
                                      (quantities[subPlan.price_id] || 0) + 1
                                    )
                                  }
                                >
                                  +
                                </button>
                              </div>
                            </td>
                          </tr>
                        )
                      )}
                    </tbody>
                  </table>
                </div>
              )}
            </div>
          )}

          <div className="mt-4 mb-2">
            {selectedGroup?.showSubUserCatalogue ? (
              <div className="flex justify-end mr-3">
                <p className="text-[#828282]">
                  Total:{" "}
                  <span className="font-medium text-black ml-4">
                    ${grandTotal.toFixed(2)} 
                  </span>
                  <span className="ml-1 text-[13px]">{selectedGroup?.currency.toUpperCase()}</span>
                </p>
              </div>
            ) : (
              <div className="flex justify-end mr-3 pb-4">
                <p className="text-[#828282]">
                  SubTotal:{" "}
                  <span className="font-medium text-black ml-4">
                    ${selectedGroup?.price?.toFixed(2) ?? "0.00"}
                  </span>
                   <span className="ml-1 text-[13px]">{selectedGroup?.currency.toUpperCase()}</span>
                </p>
              </div>
            )}

            <hr className="border-t border-gray-200 mb-4" />
            <div className="flex justify-end space-x-4">
              <Button
                className="px-6 py-1 h-[40px] rounded"
                variant="secondary"
                onClick={() => onOpenChange(false)}
              >
                Cancel
              </Button>
              <Button
                className="bg-[#181818] px-6 py-1 h-[40px]  rounded size-sm"
                onClick={onSubmit}
                disabled={isSubmitting}
              >
               Continue
              </Button>
            </div>
          </div>
        </div>
      </DialogContent>
    </Dialog>
  );
};

export default SubscriptionInitialdaialog;
